export default "__VITE_ASSET__6ea8bfda__"